import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function PageNotFound() {
  return (
    <>
      <Helmet>
        <title>404 Page Not Found</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <section className="gt-error-section section-padding fix section-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="gt-error-items">
                <div
                  className="gt-error-image wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <img src="../assets/img/404.png" alt="img" />
                </div>
                <h2 className="wow fadeInUp" data-wow-delay=".5s">
                  OPPS! This Page is Not Found
                </h2>
                <p className="wow fadeInUp" data-wow-delay=".3s">
                  The page requested could not be found. This could be a
                  spelling error in the URL or a removed page.
                </p>
                <Link
                  to="/"
                  className="theme-btn wow fadeInUp"
                  data-wow-delay=".5s"
                >
                  BACK TO HOME
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
